import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';
import { createRoot } from 'react-dom/client';

import { CitationNode } from './CitationNode';

export function CitationPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!editor.hasNodes([CitationNode])) {
      throw new Error('CitationPlugin: CitationNode not registered on editor');
    }

    return editor.registerNodeTransform(CitationNode, (node) => {
      const dom = node.createDOM();
      if (dom instanceof HTMLElement) {
        createRoot(dom).render(
          <CitationComponent
            paragraphIds={JSON.stringify(node.getParagraphIds())}
          />
        );
      }
    });
  }, [editor]);

  return null;
}

function CitationComponent({ paragraphIds }: { paragraphIds: string }) {
  return <span>{paragraphIds}</span>;
}
